import React from "react";
import { useState } from "react";

import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { useAppSelector } from "../store";
import { selectRep } from "../redux-store/rep/repSlice";
import { Link } from "react-router-dom";

const NoMatch = () => {
  const [FolderFound, setFolderFound] = useState("0");
  const { data: rep, status } = useAppSelector(selectRep);

  return (
    <>
      <Header prodname="404" />

      {status === "failed" && (
        <div className="error-page-content d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-7 m-auto">
                {FolderFound == "2" ? (
                  <>
                    <h3>Error Occurred!.</h3>
                    <p className="me-xxl-5 ms-xxl-5 pt-15 pb-20">
                      Your website is currently unavailable.
                    </p>
                    <p className="disc fs-5">
                      Corporate Office: <br />
                      PO Box 130, Farmington, MI 48332 USA
                    </p>
                  </>
                ) : (
                  <>
                    <h3>Error Occurred!.</h3>
                    <p className="me-xxl-5 ms-xxl-5 pt-15 pb-20">
                      We're sorry, but an unexpected error occurred on our
                      website. Our team has been notified. We will look into it as
                      soon as possible.
                    </p>
                    <p className="disc fs-5">
                      Corporate Office: <br />
                      PO Box 130, Farmington, MI 48332 USA
                    </p>
                  </>
                )}
                <div className="w-100 justify-content-center my-3">
                  <img src="/images/icon/icon_404.svg" alt="" />
                  <Link
                    to="mailto:support@ucespp.net"
                    className="fw-normal fs-6 link-primary"
                  >
                    Need help? Have questions? Email us.
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {status == "loading" && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <div className="loader-section section-left"></div>
          <div className="loader-section section-right"></div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default NoMatch;
